import { Navigate } from 'react-router-dom';

import { usePermission } from '@hooks/usePermission';
import { NAV_ROUTES } from '@constants/navRoutes';

const restrictTo = (allowedRoles: string[]) => (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => {
    const { isAuthorized, isAuthenticated } = usePermission(props.id || '', allowedRoles);

    // Redirect to login page if user is not authenticated
    if (!isAuthenticated) return <Navigate to={NAV_ROUTES.AUTH} />;

    // Redirect to page not found page if user is not authorized
    if (!isAuthorized) return <Navigate to={NAV_ROUTES.PAGE_NOT_FOUND} />;

    return <WrappedComponent {...props} />;
  };
};

export default restrictTo;
